import { createGlobalStateHook } from '@dateam/ark-react';

const userGlobal = createGlobalStateHook<Nullable<App.UserInfo>>(null);

export const useUserState = userGlobal.hook;
export const setUserState = userGlobal.setState;
export const getUserState = userGlobal.getState;